import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { SiterecordComment } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const getCommentBySiterecordIdUrl = id => `${environment.apiUrl}/siterecordcomments/siterecord/${id}`;

@Injectable()
export class SiterecordCommentService {
  constructor(private readonly httpService: HttpService) {}

  getComments(siterecordId: number): Observable<SiterecordComment[]> {
    return this.httpService.get<SiterecordComment[]>(getCommentBySiterecordIdUrl(siterecordId));
  }

  postComment(comment: SiterecordComment, siterecordId: number): Observable<Response> {
    return this.httpService.post(getCommentBySiterecordIdUrl(siterecordId), comment);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/siterecord-comment.service.ts